const Footer = () => {
  return (
    <div className="footer">
      <div className="footer-inner">
        <p className="copyright">copyright &copy; 2023 TEAM13. All right reserved.</p>
      </div>
    </div>
  )
}

export default Footer;